module.exports = __webpack_public_path__ + "img/rightArrow.c373c770.svg";